import React, { Component } from "react";
import Datetime from "react-datetime";
import Col from "react-bootstrap/Col";
import "moment/locale/es";
import "moment/locale/en-gb";

import "./MonthYearPicker.scss";
import Utility from "../../Utils/Utility";
import { APPLICATION_CONFIGURATIONS } from "../../Utils/ApplicationConfigurations";
import { Strings } from "../../Translations/i18n";

export default class MonthYearPicker extends Component {
  renderInput = (props, openCalendar, _closeCalendar) => {
    let get;
    if (this.props.countOfMonths === 2) {
      let monthYearArray = props.value.split("-");
      get = Utility.getPreviousMonthYear(
        new Date(monthYearArray[1], monthYearArray[0], 1, 0, 0, 0, 0),
        12
      );
    }
    let selectedMonthYearArray = props.value.split("-");
    return (
      <Col className="monthYearSelection">
        <span className="monthYearSelectionSection">
          {this.props.countOfMonths === 2 ? (
            <span className="monthYearSelectionText">
              {Strings(
                Utility.getLocalizationIdForMonth(
                  Utility.getIntegerValue(get.previousMonth)
                )
              )}
              {" " + get.previousYear + " to "}
            </span>
          ) : (
            <span />
          )}
          <span className="monthYearSelectionText">
            {Strings(
              Utility.getLocalizationIdForMonth(
                Utility.getIntegerValue(selectedMonthYearArray[0])
              )
            )}
            {" " + selectedMonthYearArray[1]}
          </span>
        </span>
        <i
          className="fa fa-calendar fa-lg "
          aria-hidden="true"
          onClick={openCalendar}
        />
      </Col>
    );
  };

  render() {
    return (
      <Datetime
        initialValue={new Date()}
        dateFormat="MM-YYYY"
        timeFormat={false}
        renderInput={this.renderInput}
        onChange={this.props.handleChangeMonthYearSelection}
        closeOnSelect={true}
        locale={APPLICATION_CONFIGURATIONS.applicationLanguage}
        defaultValue={Utility.getCurrentMonthYear()}
      />
    );
  }
}
